<div class="container-fluid">
  <p-toast [style]="{marginTop: '80px'}"></p-toast>
  @if (formLoading) {
    <div class="progress-spinner">
      <app-spinner [formLoading]="formLoading"></app-spinner>
    </div>
  }

  <div class="d-flex justify-content-between align-items-center">
    <h2>Payment Summary Report</h2>
    <div class="d-flex gap-2">
      @if (rowData.length > 0) {
        <button pButton type="button"
          label="Download Excel"
          icon="pi pi-file-excel"
          class="p-button-success"
          [disabled]="formLoading || rowData.length === 0"
          (click)="downloadExcel()"
          >
        </button>
      }
      <app-import-export
        importEnabled="false"
        [dataRetrived]="rowData"
        (exportDataSelected)="exportSelected($event)"
        [importDisabled]="true">
      </app-import-export>
    </div>
  </div>

  @if (showSearchUI) {
    <app-search-template
      searchLabel="Search"
      [showSearchButton]=true
      [reset]=true
      [showStartDate]=true
      [showEndDate]=true
      [defaultStartDate]="defaultStartDate"
      [defaultEndDate]="defaultEndDate"
      [startDateLabel]="'Start Date'"
      [endDateLabel]="'End Date'"
      [showBlankStartAndEndDate]=true
      [displayRecordsOnPageLoad]="false"
      (doSearchCB)="loadReport($event)">
    </app-search-template>
  }

  <div class="d-flex align-items-center gap-2 my-3">
    <label for="orderId" class="mb-0">Order ID (Optional):</label>
    <input
      pInputText
      id="orderId"
      type="number"
      [(ngModel)]="orderId"
      placeholder="Enter Order ID"
      style="width: 200px;"
      (keyup.enter)="loadReport({startDate: defaultStartDate, endDate: defaultEndDate})">
    <button pButton
      type="button"
      label="Clear"
      icon="pi pi-times"
      class="p-button-secondary"
      (click)="orderId = null">
    </button>
  </div>

  <br><br>

  <div class="ag-theme-balham grid-container my-grid">
    <ag-grid-angular
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      [gridOptions]="gridOptions"
      [defaultColDef]="defaultColDef"
      (gridReady)="onGridReady($event)">
    </ag-grid-angular>
  </div>

</div>

